import { Parent } from "@/models";
import { ChildModel } from "@/services";
import { MutationTree } from "vuex";
import { ParentState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<ParentState> = {
  //setChildren
  [defineVuexName(MODULES.PARENT.COMMITS.SET_CHILDREN)](state: ParentState, payload: Array<ChildModel>) {
    state.children = payload;
  },
  //setInfo
  [defineVuexName(MODULES.PARENT.COMMITS.SET_INFO)](state: ParentState, payload: Parent) {
    state.info = payload;
  },
  //setAcceptPolicy
  [defineVuexName(MODULES.PARENT.COMMITS.SET_ACCEPT_POLICY)](state: ParentState, payload: boolean) {
    state.acceptPolicy = payload;
  },
};

export default mutations;
